import Header from '../../Containers/Header/Header';
import Footer from '../../Containers/Footer/Footer';
import classesCss from './Donate.module.css';
import {useState, useEffect} from 'react';
import DonateCheckoutInput from '../../Components/DonateCheckoutInput/DonateCheckoutInput';
import PaymentAmounts from '../../Containers/PaymentAmounts/PaymentAmounts';
import PaymentMethods from '../../Containers/PaymentMethods/PaymentMethods';
import BasicDonateForm from '../../Containers/BasicDonateForm/BasicDonateForm';
import {useForm} from 'react-hook-form';

const Donate = ({URLS, paymentAmounts, recurringPeriods}) => {
	const btnHoverColor = 'rgb(255 133 18)';
	const [btnColor, setBtnColor] = useState([
		{
			backgroundColor: btnHoverColor,
			color: 'white',
		},
		{
			color: '#D27924'
		}
	]);
	const [showOtherAmount, setShowOtherAmount] = useState(false);
	const [inputBorder, setInputBorder] = useState({
		transform: 'scaleX(0)'
	});

	const [showRecurringPeriod, setRecurringPeriod] = useState(false);
	const [paymentType, setPaymentType] = useState("one-time");
	const [donationAmount, setDonationAmount] = useState("25.00");
	const [anonymouse, setAnonymous] = useState(false);
	const [coverFees, setCoverFees] = useState(false);
	const [cardCheckout, setCardCheckout] = useState(false);
	const [braintreeClient, setBraintreeClient] = useState(null);
	const [dataCollectorClient, setDataCollectorClient] = useState(null);
	const [hostedFieldsClient, setHostedFieldsClient] = useState(null);
	const [paypalLoading, setPaypalLoading] = useState(true);
	const [paypalClient, setPaypalClient] = useState(null);

	const {register, handleSubmit} = useForm();


	// Change the button color of the payment amount design.
	const changePaymentMethodBtn = btn => {
		if (btn) {
			setBtnColor([
				{
					color: '#D27924'
				},
				{
					backgroundColor: btnHoverColor,
					color: 'white'
				}
			]);
		} else {
			setBtnColor([
				{
					backgroundColor: btnHoverColor,
					color: 'white'
				},
				{
					color: '#D27924'
				},
			]);
		}
	};

	const displayOtherAmount = btn => {
		setShowOtherAmount(paymentAmounts[btn]==='Other');
	};

	const displayBorders = idx => {
		if (paymentAmounts[idx] === "Other") {
			setTimeout(() => {
				setInputBorder([{
					transform: 'scaleX(1)'
				}, {
					transform: 'scaleY(1)'
				}])
			}, 250);
		} else {
			if (inputBorder !== [{
					transform: 'scaleX(0)'
				}, {
					transform: 'scaleY(0)'
				}]) {
				setInputBorder([{
					transform: 'scaleX(0)'
				}, {
					transform: 'scaleY(0)'
				}]);
			}
		}
	}

	const getHostedFieldPayload = hostedInstance => hostedInstance.tokenize().then(payload=>payload);

	const changeRecurringPeriod = setting => {
		setRecurringPeriod(Boolean(setting));
	};

	const createPaypalCheckout = client => window.braintree.paypalCheckout.create({client}).then(paypalCheckoutInstance => paypalCheckoutInstance);


	const getDonationAmount = () => donationAmount;

	useEffect(() => {
		const getClientToken = () => fetch("https://api-tedoi.herokuapp.com/client_token").then(resp => resp.json());
		const createClient = auth => window.braintree.client.create({
		  authorization: auth
		}).then(clientInstance=>clientInstance);

		const createDataCollector = client => window.braintree.dataCollector.create({
			client,
		}).then(dataCollectorInstance => dataCollectorInstance);

		const loadPaypal = async (dataCollector, client, paypalCheckout) => {
			console.log(paypalCheckout)
			paypalCheckout.loadPayPalSDK({
				vault: true,
				locale: 'en_US',
				currency: 'USD'
			}).then(() => {
				const paypal = window.paypal;
			  return paypal.Buttons({
			    fundingSource: paypal.FUNDING.PAYPAL,

			    createBillingAgreement: () => {
			      return paypalCheckout.createPayment({
			        flow: 'vault',
							currency: 'USD',
							displayName: 'Fundacion Tedoi',
							landingPageType: 'billing',
							lineItems: [
								{
									unitAmount: donationAmount,
									quantity: '1',
									name: `${donationAmount} dollar donation`,
									kind: 'debit',
								}
							],
							billingAgreementDescription: 'Your agreement description agree descriptions'
			      });
			    },

			    onApprove: data => paypalCheckout.tokenizePayment(data).then(payload => {
						fetch("https://api-tedoi.herokuapp.com/donate", {
							method: "POST",
							body: JSON.stringify({
								donationAmount,
								payment_method_nonce: payload.nonce,
								deviceData: dataCollector.deviceData,
							}),
							redirect: "follow",
							headers: {
								"Content-Type": "application/json"
							}
						}).then(resp => resp.json()).then(console.log).catch(console.log);
					}),

			    onCancel: data => {
			      console.log('PayPal payment canceled', JSON.stringify(data, 0, 2));
			    },

			    onError: err => {
			      console.error('PayPal error', err);
			    }
			  }).render('#paypal-button');
			}).finally(() => {
				setPaypalLoading(false);
			})
		}

		const initialize = async () => {
			const token = await getClientToken();
			const client = await createClient(token);
			const dataCollector = await createDataCollector(client);
			const paypalCheckout = await createPaypalCheckout(client);

			setBraintreeClient(client);
			setDataCollectorClient(dataCollector);
			setPaypalClient(paypalCheckout);

			loadPaypal(dataCollector, client, paypalCheckout);
		}

		if (!braintreeClient) {
			initialize();
		}

		if (paypalLoading && braintreeClient) {
			loadPaypal(dataCollectorClient, braintreeClient, paypalClient);
		}

		if (cardCheckout) {
			const createHostFields = client => window.braintree.hostedFields.create({
				client,
				styles: {
					'input': {
						'font-size': '14px'
					},
					'input.invalid': {
						'color': 'red'
					},
				},
				fields: {
					number: {
						container: '#card-number',
						placeholder: 'Card number',
						maxCardLength: 16
					},
					cvv: {
						container: '#cvv',
						placeholder: 'CVV',
						type: 'password'
					},
					expirationDate: {
						container: '#expiration-date',
						placeholder: 'MM/YY',
					},
				}
			}).then(hostedFieldsInstance => hostedFieldsInstance);
			createHostFields(braintreeClient).then((hostedClients) => {
				setHostedFieldsClient(hostedClients);
			});
		}
	}, [cardCheckout, donationAmount]);

	const submitForm = async data => {
		const hostedFieldsPayload = await getHostedFieldPayload(hostedFieldsClient);

		fetch("https://api-tedoi.herokuapp.com/donate", {
			method: "POST",
			body: JSON.stringify({
				donationAmount,
				payment_method_nonce: hostedFieldsPayload.nonce,
				deviceData: dataCollectorClient.deviceData,
			}),
			redirect: "follow",
			headers: {
				"Content-Type": "application/json"
			}
		}).then(resp => resp.json()).then(console.log)
		.catch(console.log);
	}

	const handleCardCheckout = () => {
		if (cardCheckout) {
			setCardCheckout(false);
		} else {
			setCardCheckout(true);
		}
	}

	return (
		<>
			{/*<Header URLS={URLS}/>*/}
	 		<div className={classesCss.donate__main}>
			 	<div className={classesCss.donate__checkout}>
			 		<div className={classesCss.donate__container}>
			 			<h1 className={classesCss.donate__title}>
			 				Change the way the world tackles poverty
			 			</h1>
			 			<h3 className={classesCss.donate__description}>
			 				For 20 years Acumen has leveraged the tools of business to ensure everyone can live in dignity.
			 				Your donation helps us support innovative companies, train the next generation of entrepreneurs, and scale
			 				the most effective solutions to poverty.
			 				Together we’re transforming the lives of more than 309 million people.
			 			</h3>
			 			<PaymentMethods colors={btnColor} handle={idx => {
			 				changePaymentMethodBtn(idx)
			 				changeRecurringPeriod(idx)
			 			}}/>
			 			<h2>Select an amount *</h2>
			 			<PaymentAmounts paymentAmounts={paymentAmounts} handle={(idx) => {
			 				displayBorders(idx);
			 				displayOtherAmount(idx);
							setPaypalLoading(true);
			 			}} setDonationAmount={(amount) => {
							setDonationAmount(`${amount}.00`);
						}}/>
			 			{
			 				showOtherAmount ? <DonateCheckoutInput
							stylesCss={"mt-0 mb-[20px]"}
							label={"Amount"} inputBorder={inputBorder}/> : null
			 			}
			 			{
			 				showRecurringPeriod ?
			 					<DonateCheckoutInput label={"Recurring Period"}
			 								 defaultType={false}
											 stylesCss={"mt-[20px] mb-0"}
			 								 periods={recurringPeriods}/> : null
			 			}
			 		</div>
			 		<BasicDonateForm paymentType={paymentType}
			 			donationAmount={donationAmount}
						cardCheckout={cardCheckout}
						handleSubmit={handleSubmit}
						submitForm={submitForm}
						register={register}
						loading={paypalLoading}
						handleCardCheckout={handleCardCheckout}/>
			 	</div>
			 	<div className={classesCss.donate__questions}>

			 	</div>
			</div>
			<Footer URLS={URLS}/>
		</>
	);
};

export default Donate;
